import apiService, { buildQueryString } from './api';
export class ClientesService {
    // Criar cliente
    async createCliente(clienteData) {
        const response = await apiService.post('/clientes', clienteData);
        return response.data;
    }
    // Listar clientes com filtros e paginação
    async getClientes(filters = {}) {
        const queryString = buildQueryString(filters);
        const response = await apiService.get(`/clientes${queryString}`);
        return {
            data: response.data,
            pagination: response.pagination
        };
    }
    // Obter cliente por ID
    async getClienteById(id) {
        const response = await apiService.get(`/clientes/${id}`);
        return response.data;
    }
    // Atualizar cliente
    async updateCliente(id, clienteData) {
        const response = await apiService.put(`/clientes/${id}`, clienteData);
        return response.data;
    }
    // Remover/desativar cliente
    async deleteCliente(id) {
        await apiService.delete(`/clientes/${id}`);
    }
    // Buscar clientes (para autocomplete)
    async searchClientes(termo) {
        const response = await apiService.get(`/clientes/search?termo=${encodeURIComponent(termo)}`);
        return response.data;
    }
    // Obter estatísticas do cliente
    async getClienteStats(id) {
        const response = await apiService.get(`/clientes/${id}/stats`);
        return response.data;
    }
    // Validar NIF português
    validateNIF(nif) {
        if (!nif || nif.length !== 9)
            return false;
        const digits = nif.split('').map(Number);
        const checkDigit = digits[8];
        let sum = 0;
        for (let i = 0; i < 8; i++) {
            sum += digits[i] * (9 - i);
        }
        const remainder = sum % 11;
        const calculatedCheck = remainder < 2 ? 0 : 11 - remainder;
        return calculatedCheck === checkDigit;
    }
    // Validar código postal português
    validateCodigoPostal(codigo) {
        const pattern = /^\d{4}-\d{3}$/;
        return pattern.test(codigo);
    }
    // Validar número de Cartão de Cidadão
    validateCartaoCidadao(numero) {
        const pattern = /^\d{8}[A-Z]\d{2}[A-Z]\d$/;
        return pattern.test(numero);
    }
    // Validar telefone português
    validateTelefone(telefone) {
        const pattern = /^(\+351)?[0-9]{9}$/;
        return pattern.test(telefone);
    }
    // Formatar telefone português
    formatTelefone(telefone) {
        const cleaned = telefone.replace(/\D/g, '');
        if (cleaned.length === 9) {
            return `+351${cleaned}`;
        }
        if (cleaned.length === 12 && cleaned.startsWith('351')) {
            return `+${cleaned}`;
        }
        return telefone;
    }
    // Formatar código postal
    formatCodigoPostal(codigo) {
        const cleaned = codigo.replace(/\D/g, '');
        if (cleaned.length === 7) {
            return `${cleaned.substring(0, 4)}-${cleaned.substring(4)}`;
        }
        return codigo;
    }
    // Formatar NIF
    formatNIF(nif) {
        return nif.replace(/\D/g, '').substring(0, 9);
    }
    // Gerar número de cliente automático
    generateClienteNumber() {
        const timestamp = Date.now().toString().slice(-6);
        const random = Math.floor(Math.random() * 100).toString().padStart(2, '0');
        return `CL${timestamp}${random}`;
    }
}
// Instância singleton
const clientesService = new ClientesService();
export default clientesService;
